import {TableColumn, TableValueAction} from '../../../shared';
import {Empresa} from './empresa.model';

export interface EmpresaTableColumn extends TableColumn {
  literalFormat?: (v: any) => string;
  actionFormat?: (empresa: Empresa, sources?: EmpresaTableSources) => TableValueAction;
}

export interface EmpresaTableParams {
  columns?: EmpresaTableColumn[];
  empresas: Empresa[];
  sources: EmpresaTableSources;
  filter?: boolean;
  pagination?: boolean;
}

export interface EmpresaTableSources {
  rolId: string;
}


